import { useCallback } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";

function useRemoveImage() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const removeImage = useCallback(
    (image_id) => {
      fetchWrapper({
        endpoint_url: "image/removeImage",
        params: {
          image_id: image_id,
        },
        onSuccess: (fetch_output) => {
          if ("error" in fetch_output) {
            showMessage({ message: fetch_output.error });
          }
        },
        onFetchError: () =>
          showMessage({ apiType: "fetch", message: "Remove Image" }),
        onResponseError: () =>
          showMessage({ apiType: "response", message: "Remove Image" }),
      });
    },
    [fetchWrapper]
  );

  return { removeImage };
}

export default useRemoveImage;
